import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { H3, P } from '@ahmdigital/ui';
// @ts-expect-error - Automatic, Please fix when editing this file
import liveChatActions from '@ahmdigital/livechat/lib/actions';

import { CalloutArrow, CalloutSection, CalloutText, StyledButton } from './styles';
import { OptionBox, OptionContainer, OptionContentRow } from '../contact-option/styles';
import arrowIlloDownImage from './images/arrow-illo-down.svg';
import constants from '../../../../ahm-constants';
import liveChatConfig from '../../../../utils/livechat';
import LiveChatStatus from '../../../../components/live-chat/live-chat-status';
import useLiveChat from '../../../../components/live-chat/use-live-chat';
import type { ContactProps } from '../types';

type ChatType = 'currentMember' | 'lookingToJoin';

type LiveChatProps = Readonly<{
  actions: { launch: (chatConfig: any) => void };
  chatType: ChatType;
  online: ContactProps;
  offline: ContactProps;
}>;

const LiveChat = ({ actions, chatType, offline, online }: LiveChatProps) => {
  const { isAbcSupportedAndAvailable, isOnline, messageId } = useLiveChat();
  return (
    <OptionContainer>
      {chatType === 'currentMember' && (
        <CalloutSection>
          <CalloutText looksLike="h5" variant="simpleBit">
            Skip the phone queues
          </CalloutText>
          <CalloutArrow src={arrowIlloDownImage.src} alt="Arrow pointing down" />
        </CalloutSection>
      )}
      <OptionBox data-testid="optionBox">
        <OptionContentRow variant="paddingBottomSpacer6">
          {chatType === 'lookingToJoin' && !isAbcSupportedAndAvailable && !isOnline ? (
            <>
              <H3 looksLike="h4" variant={['marginBottomSpacer11']}>
                {offline.title}
              </H3>
              <P variant={['small14', 'withoutMargin']}>{offline.subText}</P>
            </>
          ) : (
            <>
              <H3 looksLike="h4" variant={['marginBottomSpacer11']}>
                {online.title}
              </H3>
              <P variant={['small14', 'withoutMargin']}>{online.subText}</P>
            </>
          )}
        </OptionContentRow>
        <OptionContentRow variant="paddingBottomSpacer11">
          <>
            <LiveChatStatus isOnline={isOnline} />
            {isAbcSupportedAndAvailable ? (
              <StyledButton to={`${constants.URLS.THIRD_PARTY.APPLE_BUSINESS_CHAT}${messageId}`}>
                {isOnline ? online.buttonText : offline.buttonText}
              </StyledButton>
            ) : (
              <div>
                {isOnline ? (
                  <StyledButton onClick={() => actions.launch(liveChatConfig)}>{online.buttonText}</StyledButton>
                ) : (
                  chatType === 'lookingToJoin' && (
                    <StyledButton to={offline.buttonUrl}>{offline.buttonText}</StyledButton>
                  )
                )}
              </div>
            )}
          </>
        </OptionContentRow>
      </OptionBox>
    </OptionContainer>
  );
};

type DispatchProps = Readonly<{
  actions: { launch: (chatConfig: any) => void };
}>;

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  actions: bindActionCreators(liveChatActions, dispatch),
});

export default connect(null, mapDispatchToProps)(LiveChat);

export { LiveChat as LiveChatForTest, mapDispatchToProps };
